import { Page } from 'components/layout';
import styled from 'styled-components/macro';
import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import futuraIcon from 'img/futura-icon.svg';
import TraitTabs from 'components/Traits/TraitTabs';
import { TRAITS_MEDIA_FILES } from '../../constants';

const Container = styled.div`
  margin: 16px auto;
  max-width: 1200px;
  width: 100%;
  padding: 0 16px;

  a {
    color: white !important;
  }

  ul > li {
      margin: 16px 0;
    }
  }

  ol > li {
    margin: 8px 0;
  }
`;

const TraitsPage = () => {
  return (
    <Page
      title="Traits and Rarities"
      p="0"
      background="#333"
      fixedFooter={false}
      showHeader
      showFooter
    >
      <Box backgroundColor="black" borderTop="1px solid #333">
        <Container>
          <Box width="100%" p={[3, 4]}>
            <Row>
              <Col xs={12} sm={12} md={5}>
                <Flex
                  width="100%"
                  height="100%"
                  backgroundColor="#6F848F"
                  borderRadius="8px"
                  textAlign="center"
                  mb={3}
                  justifyCenter
                  alignCenter
                >
                  <video width="100%" height="320px" preload="auto" muted autoPlay loop>
                    <source src={TRAITS_MEDIA_FILES.cover} type="video/mp4"></source>
                  </video>
                </Flex>
              </Col>

              <Col xs={12} sm={12} md={7}>
                <Box p={3} background="#111" borderRadius="8px" maxWidth="800px">
                  <Flex alignCenter>
                    <img src={futuraIcon} width="24px" alt="infinity" style={{ opacity: 0.5 }} />
                    <Box ml={3} fontWeight="bold" fontSize={3}>
                      The music and art of Futura
                    </Box>
                  </Flex>

                  <Box fontWeight="bold" my={3}>
                    MUSIC
                  </Box>
                  <Box my={3}>
                    Futura blends human-crafted and automated music generation. Mix NFTs comprise
                    unique clips, enabling remixes and royalties. Instant royalties for music were
                    pioneered by EulerBeats in early 2021, and Futura is taking it to the next
                    level.
                  </Box>

                  <Box fontWeight="bold" my={3}>
                    ART
                  </Box>
                  <Box my={3}>
                    Futura's NFTs push the 3D generative art boundaries with Möbius strip-shaped
                    visuals. In a nod to Leonhard Euler, the non-orientable surface visuals are
                    unique to each song and clip that comprises them.
                  </Box>
                </Box>
              </Col>
            </Row>
          </Box>
        </Container>
      </Box>

      <Box maxWidth="1200px" width="100%" margin="0 auto">
        <TraitTabs />
      </Box>
    </Page>
  );
};

export default TraitsPage;
